// Single source of truth for timezone
const TIMEZONE = 'America/Guadeloupe';

// Convert UTC ISO string to Guadeloupe date object
const toGuadeloupeDate = (isoString) => {
  return new Date(new Date(isoString).toLocaleString('en-US', { timeZone: TIMEZONE }));
};

// Format date for display (e.g., "4 février 2025")
const formatDisplayDate = (isoString) => {
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: TIMEZONE
  }).format(new Date(isoString));
};

// Format time for display (e.g., "07:30")
const formatDisplayTime = (isoString) => {
  return new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: TIMEZONE
  }).format(new Date(isoString));
};

// Get YYYY-MM-DD format in Guadeloupe timezone for calendar
const getCalendarDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString('fr-CA', { // fr-CA gives YYYY-MM-DD format
    timeZone: TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

export {
  toGuadeloupeDate,
  formatDisplayDate,
  formatDisplayTime,
  getCalendarDate
};